<template>
  <div>
    <div v-if="headerTemplate == 'ahlia'" class="print-header">
      <header style="padding-bottom: 20px;">
        <table style="width: 100%;font-size: 18px; " :style="`direction:${this.sharedLayoutDirection}`">
          <tbody>
            <tr>
              <td style="width: 35%;text-align: right;">
                <div style="font-weight: bold;margin-bottom:5px;">
                   {{ school && school.name_ar ? school.name_ar : Lang.get('messages.site_name_ar') }}
                </div>
                <div style="font-size: 15px;">
                  <p v-if="school && school.address" style="font-weight: bold;margin-bottom:5px;">{{ Lang.get('messages.address') }} : {{ school.address }} </p>
                  <p v-if="school && school.phone" style="font-weight: bold;margin-bottom:5px;">{{ Lang.get('messages.phone') }} : {{ school.phone }}</p>
                  <p v-if="school && school.fax_number" style="font-weight: bold;margin-bottom:5px;">{{ Lang.get('messages.fax') }} : {{ school.fax_number }}</p>
                </div>
              </td>
              <td style="text-align: center;">
                <div v-if="school">
                  <img :src="school.logo ? school.logo : headerImg" alt="school logo" style="height: 150px" />
                </div>
              </td>
              <td style="width: 35%;text-align: left;">
                <div style="font-weight: bold;margin-bottom:5px;">
                  {{ school && school.name_en ? school.name_en : Lang.get('messages.site_name_en') }}
                </div>
                <div style="font-size: 15px;">
                  <div v-if="school">
                    <p v-if="school.address" style="font-weight: bold;margin-bottom:5px;">Address : {{ school.address }} </p>
                    <p v-if="school.phone" style="font-weight: bold;margin-bottom:5px;">Phone : {{ school.phone }}</p>
                    <p v-if="school.fax_number" style="font-weight: bold;margin-bottom:5px;">Fax : {{ school.fax_number }}</p>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </header>
      <div class="body-content" style="font-size: 20px;" v-if="title">
        <div>
          <table style="width: 100%;">
            <tr>
              <td style="width: 35%;"></td>
              <td style=" text-align: center;">
                <span style="text-align: center; display: inline-block; margin: 10px 0;">
                  <p v-if="title"><b> {{ title }} </b></p>
                  <p v-if="title && showDate"><b> {{ moment().format('DD/M/YYYY hh:mm') }}</b></p>
                  <p v-if="academic_year"><b> {{ this.Lang.get('messages.academic_year') }} - {{ academic_year }}</b></p>
                  <p v-if="fromDate || toDate"><b>
                      <span v-if="fromDate">{{ Lang.get('messages.from') }}: {{ fromDate }}</span>
                      <span v-if="toDate">{{ Lang.get('messages.to')
                        }}:{{ toDate ?? moment().format('DD-MMMM-YYYY') }}</span>
                    </b></p>
                </span>
              </td>
              <td style="width: 35%; text-align: center;"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div v-if="headerTemplate == 'shayee'">
      <table></table>
    </div>
  </div>
</template>

<script>
import Lang from "../../lang";
import { mapState } from "vuex";

export default {
  name: "PrintHeader",
  props: {
    title: {
      type: [String],
      required: false
    },
    academic_year: {
      type: [String],
      required: false
    },
    fromDate: {
      type: [String],
      required: false
    },
    toDate: {
      type: [String],
      required: false,
    },
    showDate: {
      type: [Boolean],
      default: true
    },
    headerImg: {
      type: [String],
      required: false,
      default: '/images/ahlia-kuwait-school.jpg',
    },
    schoolProp: {
      type: Object,
      required: false
    }

  }, computed: {
    ...mapState("users", ["user"]),

    school() {
      return this.schoolProp || this.user.school;
    },
  },
  data() {
    return {
      headerTemplate: this.$mods.print.header
    }
  }
}

</script>

<style>
.print-header {
  display: none;
}
</style>